import { render, staticRenderFns } from "./kpi-data-chart.vue?vue&type=template&id=aa38b2f2&scoped=true"
import script from "./kpi-data-chart.vue?vue&type=script&lang=js"
export * from "./kpi-data-chart.vue?vue&type=script&lang=js"
import style0 from "./kpi-data-chart.vue?vue&type=style&index=0&id=aa38b2f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa38b2f2",
  null
  
)

export default component.exports